import { yupResolver } from "@hookform/resolvers/yup";
import { forwardRef, useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { LinearContactInfo, LinearContactInfoItemUi } from "../../types/communication/communicationDataType";
import InputCmp from "../input/InputCmp"
import { ContactItemContainer } from "../styled/Input.style";
import { CaiContactInfoForm } from "../styled/page-custom/Cai.style";
import { genericStateReducer } from "./genericStateReducer";

export const ContactInfoStateAction = {
    UPDATE_STATE: '@@contactInfo/UPDATE_STATE'
}

export interface ContactInfoCmpProps {
    initValues: LinearContactInfo;
    contactItems: LinearContactInfoItemUi[]
    onContactChange?: (updValues: Partial<LinearContactInfo>) => void,
    validationSchema?: any,
    onValiddationStateChange?: any
}

// Use React.forwardRef
const LinearCtpInfoCmp = forwardRef(({ ...props }: ContactInfoCmpProps, ref) => {

    const { initValues, contactItems, onContactChange, validationSchema, onValiddationStateChange
    } = props
    const [contactInfoState, contactInfoDispatch] = useReducer(genericStateReducer<LinearContactInfo>(ContactInfoStateAction), initValues);

    useEffect(() => {
        onContactChange && onContactChange(contactInfoState)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contactInfoState])

    const { register, handleSubmit, formState } = useForm({
        resolver: yupResolver(validationSchema),
        mode: "onChange"
    });

    useEffect(() => {
        onValiddationStateChange && onValiddationStateChange(formState)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formState?.isValid])

    const onSubmit = () => { };
    

    return (
        <CaiContactInfoForm onSubmit={handleSubmit(onSubmit)}>
            {contactItems && contactItems.map((ctItem) => {
                return <ContactItemContainer key={ctItem.propName}>
                    {<InputCmp
                        value={(contactInfoState)[ctItem.propName] || ''}
                        setValue={(val: any) => {
                            const updObj: Partial<LinearContactInfo> = {}
                            updObj[ctItem.propName] = val;
                            contactInfoDispatch({ type: ContactInfoStateAction.UPDATE_STATE, payload: { ...updObj } })
                        }}
                        name={ctItem.propName}
                        label={ctItem.label}
                        placeholder={ctItem.placeholder}
                        labelClassName="marked"
                        className={`contact-info small ${ctItem.companyName}`}
                        register={register}
                        errors={formState?.errors}
                        companyName={ctItem.companyName}
                    />}
                </ContactItemContainer>
            })}
        </CaiContactInfoForm>
    )
})

export default LinearCtpInfoCmp